import React from 'react';

const Sort = ({ ...attrs }) => (
  <svg viewBox="0 0 64 48" {...attrs} width="1.3em">
    <g transform="translate(0,-9.25)">
      <rect
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x="14.5"
        y="16.8"
        width="35.7"
        height="6.5"
      />
      <rect
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x="14.5"
        y="30"
        width="35.7"
        height="6.5"
      />
      <rect
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x="14.5"
        y="43.2"
        width="35.7"
        height="6.5"
      />
    </g>
    <g transform="translate(0 -9.3)">
      <polyline
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        points="2.1 28.4 5.9 22.6 9.8 28.4"
      />
      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="6"
        x2="6"
        y1="44"
        y2="23.4"
      />
    </g>
    <g transform="translate(0 -9.3)">
      <polyline
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        points="62.7 38.1 58.8 44 54.9 38.1"
      />
      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="58.8"
        x2="58.8"
        y1="22.6"
        y2="43.2"
      />
    </g>
  </svg>
);

export default Sort;
